import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["sidebar", "label", "logo"]
  static values = {
    collapsed: { type: Boolean, default: false }
  }

  connect() {
    // Restore state from localStorage
    const saved = localStorage.getItem("sidebar-collapsed")
    if (saved === "true") {
      this.collapsedValue = true
      this.applyState()
    }
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    localStorage.setItem("sidebar-collapsed", this.collapsedValue)
    this.applyState()
  }

  applyState() {
    // Use the html class for all CSS-based styling (including icon rotation)
    document.documentElement.classList.toggle("sidebar-collapsed", this.collapsedValue)

    if (this.collapsedValue) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  collapse() {
    // Sidebar width
    this.sidebarTarget.classList.remove("lg:w-[280px]")
    this.sidebarTarget.classList.add("lg:w-[72px]")

    // Hide labels
    this.labelTargets.forEach(label => {
      label.classList.add("lg:hidden")
    })

    // Hide logo text
    if (this.hasLogoTarget) {
      this.logoTarget.classList.add("lg:hidden")
    }
  }

  expand() {
    // Sidebar width
    this.sidebarTarget.classList.remove("lg:w-[72px]")
    this.sidebarTarget.classList.add("lg:w-[280px]")

    // Show labels
    this.labelTargets.forEach(label => {
      label.classList.remove("lg:hidden")
    })

    // Show logo text
    if (this.hasLogoTarget) {
      this.logoTarget.classList.remove("lg:hidden")
    }
  }
}
